const headerMenu = document.getElementsByClassName('component-header-menu');
Array.from(headerMenu).forEach((headerMenu) => {
  // toggle with link
  const headerMenuLinks = headerMenu.querySelectorAll('.js-toggle-link');
  headerMenuLinks.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const currentItem = item.closest('li');
      const headerMenuItems = item.closest('ul').querySelectorAll(':scope > li');
      headerMenuItems.forEach(function(item) {
        if(this.currentItem !== item) {
          item.classList.remove('is-open');
        }else{
          item.classList.toggle('is-open');
        }
      }, { currentItem: currentItem })
    })
  })
  // toggle with icon
  const headerMenuIcons = headerMenu.querySelectorAll('.js-toggle-icon');
  headerMenuIcons.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const currentItem = item.closest('li');
      const headerMenuItems = item.closest('ul').querySelectorAll(':scope > li');
      headerMenuItems.forEach(function(item) {
        if(this.currentItem !== item) {
          item.classList.remove('is-open');
        }else{
          item.classList.toggle('is-open');
        }
      }, { currentItem: currentItem })
    })
  })
})

// hide menu when clicked outside
// https://stackoverflow.com/questions/14188654/detect-click-outside-element-vanilla-javascript
var specifiedElement = document.querySelector('.component-header-menu');
document.addEventListener('click', function(event) {
  var isClickInside = specifiedElement.contains(event.target);
  if (!isClickInside) {
    const headerMenuItems = specifiedElement.querySelectorAll('.is-open');
    headerMenuItems.forEach(item => {
      item.classList.remove('is-open');
    })
  }
});
